<script>
import TableWithPagination from '../table-with-pagination';
import {addQueryParams} from '../../libs/url';
import ActionsColumn from './actions-column';
import eventBus from '../../event-bus';
import BrandColumn from './columns/brand-column';
import TagsColumn from './columns/tags-column';

export default {
  extends: TableWithPagination,

  components: {
    BrandColumn,
    ActionsColumn,
    TagsColumn,
  },

  data() {
    return {
      search: null,
      filters: {},
      isBusy: false,
    };
  },

  computed: {
    /**
     * @return {string}
     */
    urlWithFilters() {
      return addQueryParams(this.url, this.filters);
    },
  },

  watch: {
    search(current, previous) {
      this.filters = current
          ? _.assign({}, this.filters, {search: current})
          : this.filters = _.omit(this.filters, ['search']);
    },
  },

  methods: {
    /**
     * @param {object} row
     * @param {object} col
     * @param {string} datetime
     * @return {string}
     */
    formatDate(row, col, {datetime}) {
      return moment(datetime).format(config('format.moment.short.datetime'));
    },

    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.baseTable.refresh();
    },

    /**
     * @emits show-approved-message-form-dialog
     */
    onCreate() {
      eventBus.$emit('show-approved-message-form-dialog', this.createUrl);
    },

    /**
     * @param {string} url
     * @emits show-approved-message-form-dialog
     */
    onEdit({url}) {
      eventBus.$emit('show-approved-message-form-dialog', url);
    },

    /**
     * @param {string} url
     */
    onDelete({url}) {
      this.submitAction(url, {_method: 'DELETE'});
    },

    /**
     * @param {string} url
     */
    onApprove({url}) {
      this.submitAction(url);
    },

    /**
     * @param {string} url
     */
    onReject({url}) {
      this.submitAction(url);
    },

    /**
     * @param {string} url
     * @param {object} payload
     */
    submitAction(url, payload = {}) {
      this.isBusy = true;
      axios.post(url, payload)
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
            eventBus.$emit('notifications:refresh');
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          })
          .then(() => this.isBusy = false);
    },
  }
}
</script>
